import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { REQUEST_STATUS } from '../../../constants/request'
import { useContentOverflow } from '../../../hooks'
import { stopPropagation } from '../../../utils/events'
import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'
import Button, { BUTTON_HEIGHT_24 } from '../../Button'
import { EntityArchivedIcon, EntityStatus } from '../../Entity'
import { FloatingTooltip } from '../../Floating'
import { STATUS_SIZE_24 } from '../../Status'
import { getRequestTitle } from '../Request.utils'

import * as styles from './RequestAttachTag.module.css'

import DeleteIcon from '../../../icons/delete.svg'
import ServiceRequestIcon from '../../../icons/service-request.svg'

function RequestAttachTag({ disabled, item, onDelete }) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const { t } = useTranslation()

  const requestTitle = getRequestTitle({
    requestNumber: item.request_no,
    title: item.title,
  })

  function handleDelete(event) {
    stopPropagation(event)

    onDelete(item.id)
  }

  return (
    <div
      className={classNames(styles.container, { [styles.disabled]: disabled })}
    >
      <div className={styles.nameContainer}>
        <Avatar Icon={ServiceRequestIcon} size={AVATAR_HEIGHT_24} />
        <FloatingTooltip content={requestTitle} disabled={!overflow}>
          <span className={styles.title} ref={setContentOverflowRef}>
            {requestTitle}
          </span>
        </FloatingTooltip>
      </div>
      <div className={styles.statusContainer}>
        {item.archived ? <EntityArchivedIcon /> : null}
        {Number.isFinite(item.status) ? (
          <EntityStatus
            height={STATUS_SIZE_24}
            id={item.status}
            statuses={REQUEST_STATUS}
          />
        ) : null}
        {onDelete && !disabled ? (
          <Button.Outlined
            isGrey
            beforeIconProps={{ Icon: DeleteIcon }}
            height={BUTTON_HEIGHT_24}
            tooltip={t('Request.AttachTagDeleteButtonTooltipTextKey')}
            onClick={handleDelete}
          />
        ) : null}
      </div>
    </div>
  )
}

export default RequestAttachTag
